import { Observable, timeout } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService, HTTP_REQUESTS_TIMEOUT, StockItem, urls } from 'src/app/core';
import {
  CreateNewBindingDto,
  StockCreateSize,
  TalcColor,
  UpdateBindingSalaryFee,
} from 'src/app/shared';

@Injectable({ providedIn: 'root' })
export class StockService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  /// get all from stock?
  public all() {
    try {
      const url = this.configService.getUrl('stock.stocks') || '';
      return this.http
        .get<StockItem[]>(url, {
          withCredentials: true,
        })
        .pipe(timeout(HTTP_REQUESTS_TIMEOUT));
    } catch (errors) {
      throw errors;
    }
  }

  public getById(id: number): Observable<StockItem> {
    return new Observable((subscriber) => {
      const url = this.configService.getUrl('stock.getById');

      this.http
        .get<StockItem>(url + id)
        .pipe(timeout(HTTP_REQUESTS_TIMEOUT))
        .subscribe(
          (data) => {
            subscriber.next(data);
          },
          (error) => {
            subscriber.error(error);
          }
        );
    });
  }

  /// get all from stock?
  // public allAsync(): Observable<StockItem[]> {
  //   return new Observable((subscriber) => {
  //     const url = this.configService.getUrl('stock.stocks');

  //     this.http
  //       .get<StockItem[]>(url)
  //       .pipe(timeout(HTTP_REQUESTS_TIMEOUT))
  //       .subscribe((stocks) => {
  //         subscriber.next(stocks);
  //       });
  //   });
  // }

  public getTalcColors(): Observable<TalcColor[]> {
    const url = this.configService.getUrl('stock.talcColors');
    return this.http
      .get<TalcColor[]>(url, { withCredentials: true })
      .pipe(timeout(HTTP_REQUESTS_TIMEOUT));
  }

  public getTalcColorById(id: number | string): Observable<TalcColor> {
    const url = this.configService
      .getUrl('colors.readOne', 2)
      .replace(':id', `${id}`);

    return this.http.get<TalcColor>(url, { withCredentials: true });
  }

  public updateTalcColor(
    id: number | string,
    updateBody: any
  ): Observable<TalcColor> {
    const url = this.configService
      .getUrl('colors.update', 2)
      .replace(':id', `${id}`);

    return this.http.patch<TalcColor>(url, updateBody, {
      withCredentials: true,
    });
  }

  public getByName(name: string) {
    const url = this.configService
      .getUrl('stock.getByName')
      .replace(':name', name);

    return this.http.get<StockItem[]>(url, { withCredentials: true });
  }
  public getBindSalaryFee(key: string) {
    const url = this.configService
    .getUrl('settings.bindSalaryFee', 3).replace(':key', `${key}`);

    return this.http.get<any>(url, { withCredentials: true });
  }


  /**
   * Add size monolog.
   */
  public addSize(dto: StockCreateSize): Observable<StockItem[]> {
    const url = this.configService.getUrl('stock.addSize');
    return this.http.post<StockItem[]>(url, dto, { withCredentials: true });
  }

  public updateSize(dto: StockCreateSize): Observable<StockItem[]> {
    const url = this.configService.getUrl('stock.updateSize');
    return this.http.put<StockItem[]>(url, dto, { withCredentials: true });
  }

  public addBinding(dto: CreateNewBindingDto) {
    const url = this.configService.getUrl('stock.addBinding');
    return this.http.post<StockItem>(url, dto, { withCredentials: true });
  }

  public updateBinding(dto: CreateNewBindingDto) {
    const url = urls.admin.stock.binding;
    return this.http.put<StockItem>(url, dto, { withCredentials: true });
  }
  public updateBindingSaralyFee(dto: UpdateBindingSalaryFee) {
    const url = urls.admin.settings.updateBindSalaryFee;
    return this.http.put<UpdateBindingSalaryFee>(url, dto, { withCredentials: true });
  }
  public deleteBinding(id: string) {
    const url = this.configService
      .getUrl('stock.deleteBinding')
      .replace(':id', id);
    return this.http.delete(url, { withCredentials: true });
  }
}
